import React from "react";
import CrudModule from "@/components/admin/CrudModule";
import { Badge } from "@/components/common/Primitives";
import { bannersCrud } from "@/services/bannersService";
import { storageService } from "@/services/storageService";

export default function AdminBannersPage() {
  return (
    <CrudModule
      title="Banners / Ads"
      description="Promotional banners and featured sponsor placements across the site."
      crud={bannersCrud}
      searchKeys={["title", "placement"]}
      columns={[
        { key: "title", label: "Banner" },
        { key: "placement", label: "Placement", render: (r) => <Badge tone="maroon">{r.placement}</Badge> },
        { key: "link_url", label: "Link" },
        { key: "sort_order", label: "Order" },
      ]}
      toggles={[
        { key: "is_active", label: "Active" },
        { key: "is_featured", label: "Featured" },
      ]}
      fields={[
        { name: "title", label: "Title", type: "text", required: true },
        { name: "subtitle", label: "Subtitle / Text", type: "text" },
        {
          name: "placement",
          label: "Placement Slot",
          type: "select",
          options: ["home_hero", "home_mid", "sponsors_page", "forum_page"],
          required: true,
        },
        {
          name: "image_url",
          label: "Banner Image",
          type: "image",
          required: true,
          onUpload: (file, hint) => storageService.uploadBannerImage(file, hint),
          folderLabel: "banners",
          nameHintFrom: "title",
        },
        { name: "link_url", label: "Click-through Link", type: "text", hint: "Internal path (/sponsors) or full URL" },
        { name: "sort_order", label: "Display Order", type: "number" },
        { name: "is_active", label: "Active", type: "checkbox", default: true },
        { name: "is_featured", label: "Featured", type: "checkbox", default: false },
      ]}
    />
  );
}
